// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyD0NS54t4dDV1EWae4cE_un9uMWsgg0L-Q",
  authDomain: "aligarh-dairy.firebaseapp.com",
  projectId: "aligarh-dairy",
  storageBucket: "aligarh-dairy.firebasestorage.app",
  messagingSenderId: "794818414019",
  appId: "1:794818414019:web:59fe64bc0ac88fa6f1a976",
  measurementId: "G-L2K0M2YBF9"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

// Collections structure
// villages: { id, name, code, createdAt }
// accounts: { id, villageId, name, phone, role, createdAt }
// transactions: { id, villageId, accountId, amount, type, date }